exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".search-result {\n  display: inline-block;\n  width: calc(100% - 20px);\n}\n.search-result > span + span {\n  margin-left: 6px;\n}\n", ""]);

